import { useMemo } from 'react';
import Papa from 'papaparse';
import useCacheLlmRawDataEffect from './useCacheLlmRawDataEffect';

interface IProps {
  analysisId: string;
  headers: string[];
  data: (string | number | null)[][];
}

const useCacheDataTableLlmRawDataEffect = ({
  analysisId,
  headers,
  data,
}: IProps) => {
  const rawData = useMemo(() => {
    return Papa.unparse({
      fields: headers,
      data,
    });
  }, [headers, data]);
  useCacheLlmRawDataEffect({
    analysisId,
    rawData,
  });
};

export default useCacheDataTableLlmRawDataEffect;
